/**
 * Custom Slideshow Section
 * Lightweight native scroll-snap slider (no external library dependency),
 * so it will keep working even if the Dawn theme's own slideshow CSS
 * is never loaded on this section.
 */

if (!customElements.get('custom-slideshow-section')) {
  class CustomSlideshowSection extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.custom-slideshow__slides');
      this.slides = Array.from(this.querySelectorAll('.custom-slideshow__slide'));
      this.prevBtn = this.querySelector('.custom-slideshow__btn--prev');
      this.nextBtn = this.querySelector('.custom-slideshow__btn--next');
      this.dots = Array.from(this.querySelectorAll('.custom-slideshow__dot'));

      this.currentIndex = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = (parseInt(this.dataset.autoplaySpeed, 10) || 5) * 1000;
      this.isUserInteracting = false;

      if (!this.track || this.slides.length === 0) return;

      if (this.slides.length > 1) {
        this.prevBtn && this.prevBtn.addEventListener('click', () => {
          this.pauseThenResume();
          this.goTo(this.currentIndex - 1);
        });

        this.nextBtn && this.nextBtn.addEventListener('click', () => {
          this.pauseThenResume();
          this.goTo(this.currentIndex + 1);
        });

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.pauseThenResume();
            this.goTo(index);
          });
        });

        this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
          root: this.track,
          threshold: 0.6,
        });
        this.slides.forEach((slide) => this.observer.observe(slide));

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => {
          if (this.autoplay) this.startAutoplay();
        });
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => {
          if (this.autoplay) this.startAutoplay();
        });

        if (this.autoplay) this.startAutoplay();
      }

      this.updateActiveDot(0);
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.observer) this.observer.disconnect();
    }

    handleIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = this.slides.indexOf(entry.target);
          if (index !== -1) {
            this.currentIndex = index;
            this.updateActiveDot(index);
          }
        }
      });
    }

    // goTo(index) {
    //   const total = this.slides.length;
    //   const nextIndex = ((index % total) + total) % total;
    //   this.slides[nextIndex].scrollIntoView({
    //     behavior: 'smooth',
    //     inline: 'start',
    //     block: 'nearest',
    //   });
    //   this.currentIndex = nextIndex;
    //   this.updateActiveDot(nextIndex);
    // }
    goTo(index) {
        const total = this.slides.length;
        const nextIndex = ((index % total) + total) % total;
        const targetSlide = this.slides[nextIndex];

        if (this.track && targetSlide) {
            this.track.scrollTo({
            left: targetSlide.offsetLeft,
            behavior: 'smooth',
            });
        }

        this.currentIndex = nextIndex;
        this.updateActiveDot(nextIndex);
        }

    updateActiveDot(index) {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => {
        this.goTo(this.currentIndex + 1);
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    pauseThenResume() {
      this.stopAutoplay();
      if (this.autoplay) {
        clearTimeout(this._resumeTimeout);
        this._resumeTimeout = setTimeout(() => this.startAutoplay(), this.autoplaySpeed);
      }
    }
  }

  customElements.define('custom-slideshow-section', CustomSlideshowSection);
}
